import { Howl } from "howler";
import {
  DEFAULT_MUSIC_VOLUME,
  DEFAULT_SFX_VOLUME,
  LOCAL_STORAGE_MUSIC_VOLUME,
  LOCAL_STORAGE_SFX_VOLUME,
} from "../helpers/consts";

export const SFX = {
  CLICK: "CLICK",
  COLLECT: "COLLECT",
  DOOR_SWITCH: "DOOR_SWITCH",
  DEATH: "DEATH",
  LEVEL_COMPLETE: "LEVEL_COMPLETE",
  UNLOCK: "UNLOCK",
  CONVEYOR: "CONVEYOR",
  ENEMIES_APPEAR: "ENEMIES_APPEAR",
  ICE: "ICE",
  JUMP: "JUMP",
  SOMETHING_APPEARS: "SOMETHING_APPEARS",
  TELEPORT: "TELEPORT",
  THUMP: "THUMP",
  TIME_WARNING: "TIME_WARNING",
  PORTAL_OPENS: "PORTAL_OPENS",
  TALK_BLIP: "TALK_BLIP",
};

const SFX_FILES = {
  [SFX.CLICK]: "./sfx/click.mp3",
  [SFX.COLLECT]: "./sfx/collect.mp3",
  [SFX.DOOR_SWITCH]: "./sfx/pop.mp3",
  [SFX.DEATH]: "./sfx/death.mp3",
  [SFX.LEVEL_COMPLETE]: "./sfx/win-alt.mp3",
  [SFX.UNLOCK]: "./sfx/unlock.mp3",
  [SFX.CONVEYOR]: "./sfx/conveyor.mp3",
  [SFX.ENEMIES_APPEAR]: "./sfx/enemies-appear.mp3",
  [SFX.ICE]: "./sfx/ice.mp3",
  [SFX.JUMP]: "./sfx/jump.mp3",
  [SFX.SOMETHING_APPEARS]: "./sfx/something-appears.mp3",
  [SFX.TELEPORT]: "./sfx/teleport.mp3",
  [SFX.THUMP]: "./sfx/thump.mp3",
  [SFX.TIME_WARNING]: "./sfx/time-warning.mp3",
  [SFX.PORTAL_OPENS]: "./sfx/portal-opens.mp3",
  [SFX.TALK_BLIP]: "./sfx/talk-blip.mp3",
};

const MUSIC_FILES = {
  MUSIC_WORLD1: "./music/song-potential-bounce2.mp3",
  MUSIC_WORLD2: "./music/song-tunnels-export2.mp3",
  MUSIC_WORLD3: "./music/song-promotion-export2.mp3",
  MUSIC_WORLD4: "./music/song-jump-the-shark-export2.mp3",
  MUSIC_BATTLE: "./music/song-ciabatta-battle-bounce2.mp3",
};

class Sounds {
  constructor() {
    this.howls = {};
    this.currentMusic = null;
    this.musicVolume = Number(
      window.localStorage.getItem(LOCAL_STORAGE_MUSIC_VOLUME) ??
        DEFAULT_MUSIC_VOLUME
    );
    this.sfxVolume = Number(
      window.localStorage.getItem(LOCAL_STORAGE_SFX_VOLUME) ??
        DEFAULT_SFX_VOLUME
    );

    this.sfxCounts = new Map();
  }

  init() {
    Object.keys(SFX_FILES).forEach((key) => {
      const file = SFX_FILES[key];
      this.howls[key] = new Howl({
        src: [file],
      });
    });
  }

  playSfx(key) {
    // Deny sfx if same one has played too recently
    if (this.isSfxPlaying(key)) {
      return;
    }

    // Make a reference to our sound in memory
    const howl = this.howls[key];
    // Play it at current volume setting
    howl.volume(this.sfxVolume);
    howl.play();

    this.registerSfxIsPlaying(key);
  }

  //Add to Map (then remove) - This is for not allowing a bunch of the same sound to trigger at the same time
  registerSfxIsPlaying(key) {
    const newValue = this.sfxCounts.get(key) ? this.sfxCounts.get(key) + 1 : 1;
    this.sfxCounts.set(key, newValue);
    setTimeout(() => {
      const newValueAfterPlay = this.sfxCounts.get(key) - 1;
      this.sfxCounts.set(key, newValueAfterPlay);
    }, 80);
  }

  isSfxPlaying(key) {
    const value = this.sfxCounts.get(key) || 0;
    return value > 0;
  }

  playMusic(key) {
    //Do not replay if we are already playing this track
    if (this.howls[key] === this.currentMusic) {
      return;
    }

    // Stop current music because we are about to play something else
    this.currentMusic?.stop();

    if (!this.howls[key]) {
      const file = MUSIC_FILES[key];
      this.howls[key] = new Howl({
        src: [file],
        loop: true,
        volume: this.musicVolume,
      });
    }
    this.currentMusic = this.howls[key];
    this.currentMusic.volume(this.musicVolume);
    this.currentMusic.play();
  }

  stopMusic() {
    this.currentMusic?.stop();
    this.currentMusic = null;
  }

  setMusicVolume(newValue) {
    this.musicVolume = newValue;
    this.currentMusic?.volume(newValue);
    window.localStorage.setItem(LOCAL_STORAGE_MUSIC_VOLUME, newValue);
  }

  setSfxVolume(newValue) {
    this.sfxVolume = newValue;
    window.localStorage.setItem(LOCAL_STORAGE_SFX_VOLUME, newValue);
  }
}

const sounds = new Sounds();
export default sounds;
